/**
 * Parse user-entered numbers that may use a comma as decimal separator (e.g. FR).
 * Supports "12,5", "12.5", "1.234,56" (EU) and "1,234.56" (US).
 */
export function parseFlexibleDecimal(input: unknown): number {
  if (input === null || input === undefined) return Number.NaN
  if (typeof input === 'number') {
    return Number.isFinite(input) ? input : Number.NaN
  }
  const raw = String(input).trim()
  if (!raw) return Number.NaN
  const s = raw.replace(/\s/g, '').replace(/\u00a0/g, '').replace(/\u202f/g, '')
  if (!s) return Number.NaN

  const lastComma = s.lastIndexOf(',')
  const lastDot = s.lastIndexOf('.')
  let normalized: string
  if (lastComma !== -1 && lastDot !== -1) {
    if (lastComma > lastDot) {
      normalized = s.replace(/\./g, '').replace(',', '.')
    } else {
      normalized = s.replace(/,/g, '')
    }
  } else if (lastComma !== -1) {
    normalized = s.replace(',', '.')
  } else {
    normalized = s
  }
  const n = Number(normalized)
  return Number.isFinite(n) ? n : Number.NaN
}
